import { arrays } from './arrays';

const EMPRESAS_POR_CODIGO = new Map(
  arrays.Empresas.map(({ value, text }) => [value, text])
);

export const utils = {
  buscaEPCodigo(store) {
    return store.getters.user?.empresaLogada;
  },

  buscaNomeEmpresa(store) {
    const epCodigo = this.buscaEPCodigo(store);
    return EMPRESAS_POR_CODIGO.get(epCodigo) ?? 'Empresa não identificada';
  },

  async salvarSessaoAutenticada({
    api,
    store,
    dadosToken,
    identificador,
    empresaLogada
  }) {
    const tokenNormalizado = {
      ...dadosToken,
      expires: dadosToken.expiresIn ?? dadosToken.expires
    };

    try {
      const usuarioRegistrado = api.UTIL.Auth.RegisterToken(
        tokenNormalizado,
        identificador
      );

      if (!usuarioRegistrado) {
        return null;
      }

      const usuario = {
        ...usuarioRegistrado,
        identificador,
        empresaLogada
      };

      await store.dispatch('setUserData', { user: usuario });
      return usuario;
    } catch {
      api.UI.ShowError('Erro', 'Não foi possível atualizar a sessão');
      setTimeout(store.dispatch('logout'), 3000);
    }
  }
};
